import React from "react";
import { Label } from "./styles";

const InputRadio = ({
  text,
  name,
  id,
  disabled = false,
  value,
  checked,
  onChange = () => {},
  onClick = () => {},
  ...rest
}) => {
  return (
    <Label htmlFor={id} disabled={disabled} onClick={(temp)=>{if(!disabled){onClick(temp)}}} {...rest}>
      <input
        type="radio"
        name={name}
        id={id}
        onChange={onChange}
        value={value}
        checked={checked}
      />
      <span className="checkmark"></span>
      {text}
    </Label>
  );
};

export default InputRadio;
